import { render, staticRenderFns } from "./GoogleIndexNotifyUpdate.vue?vue&type=template&id=98fd1120"
import script from "./GoogleIndexNotifyUpdate.vue?vue&type=script&lang=js"
export * from "./GoogleIndexNotifyUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports